var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderOrderMain',{attrs:{"img_header":_vm.img_holder,"header":"ใบกำกับสินค้า (Packing List)","link_back":"ordermain/orderpackinglist"}}),_c('Order_product_invoice')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }